import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { moreTestimonials } from '../data/testimonials';
export function MoreTestimonials() {
  return <section aria-label="Altre testimonianze" className="mx-auto mt-12 w-full max-w-4xl" data-id="element-89" data-mp="20fowudtw93h2">
      <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-90" data-mp="25ausi4d3lwic">
        ❤️ Altre persone che applicano già il metodo
      </h2>

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-91" data-mp="1ckvw1nwkqx3n">
        {moreTestimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i % 3 * 0.1} data-id="element-92" data-mp="1hjytona8611l" data-mpi={i} />)}
      </div>
    </section>;
}